import {inject, Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {UserPreferences} from '../types/user-preferences.types';
import {RecordTableProperties} from '../types/records-table.types';
import {UserPreferencesApiService} from "../services-api/user-preferences-api.service";

@Injectable({
  providedIn: 'root'
})
export class UserPreferencesService {
  private userPreferencesApiService: UserPreferencesApiService = inject(UserPreferencesApiService);

  public tableKeyForUpdatingPreferences: string | null = null;
  private userPreferences: UserPreferences | null = null;

  private _userPreferences: Subject<UserPreferences | null> = new Subject();
  public userPreferences$: Observable<UserPreferences | null> = this._userPreferences.asObservable();

  public getUserPreferences(): UserPreferences | null {
    return this.userPreferences;
  }

  public handleTableProperties(tableProperties: RecordTableProperties | null): void {
    if (!tableProperties) {
      this.setUserPreferences(null);
      this.tableKeyForUpdatingPreferences = null;
      return;
    }

    const userPreferences: UserPreferences = JSON.parse(tableProperties.UI_CONFIGURATION.value);
    this.setUserPreferences(userPreferences);
    this.tableKeyForUpdatingPreferences = tableProperties.UI_CONFIGURATION.key;
  }

  public saveUserPreferences(userPreferences: UserPreferences): void {
    if (!this.tableKeyForUpdatingPreferences) { return; }

    const value = JSON.stringify({...this.userPreferences, ...userPreferences});

    this.userPreferencesApiService.saveConfiguration(this.tableKeyForUpdatingPreferences, value)
      .subscribe({
        next: (data: {value: string}) => {
          this.userPreferences = JSON.parse(data.value);
          this._userPreferences.next(this.userPreferences);
        }
      });
  }

  public resetPreferencesToDefault(): void {
    this.userPreferences = null;
    this._userPreferences.next(null);

    if (this.tableKeyForUpdatingPreferences) {
      const emptyValue = JSON.stringify(null);

      this.userPreferencesApiService
        .saveConfiguration(this.tableKeyForUpdatingPreferences, emptyValue)
        .subscribe({
          next: (data: { value: string }) => {
            this.userPreferences = JSON.parse(data.value);
            this._userPreferences.next(this.userPreferences);
          },
        });
    }

    this.tableKeyForUpdatingPreferences = null;
  }

  private setUserPreferences(userPreferences: UserPreferences | null): void {
    this.userPreferences = userPreferences;
    this._userPreferences.next(userPreferences);
  }
}
